import type { CommonError } from 'CommonError-Types';

import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export type CommonErrorState = {
  item: CommonError;
  isUIImplementationError: boolean;
};

const initialState: CommonErrorState = {
  item: {} as CommonError,
  isUIImplementationError: false,
};

export const commonErrorSlice = createSlice({
  name: 'commonError',
  initialState,
  reducers: {
    setCommonError(state, action: PayloadAction<CommonError>) {
      state.item = action.payload;
    },
    clearCommonError(state) {
      state.item = {} as CommonError;
    },
    setIsUIImplementationError(state, action: PayloadAction<boolean>) {
      state.isUIImplementationError = action.payload;
    },
  },
});

export const { setCommonError, clearCommonError, setIsUIImplementationError } =
  commonErrorSlice.actions;
export const commonErrorReducer = commonErrorSlice.reducer;
